import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { auth, storage, analytics } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth'; 
import { ref, listAll, getDownloadURL } from 'firebase/storage';
import { logEvent } from 'firebase/analytics';
import { Analytics } from '@vercel/analytics/react';
import ParticlesComponent from './components/particles';
import Draw from './components/draw';
import Draw2 from './components/draw2';
import Us from './components/us';
import MyDrawings from './components/myDrawings';
// import Picture from './components/picture';
import Blog from './components/blog';
import ArticleDetail from './components/articleDetail';
import Error from './components/error';
import Languages from './components/languages';
import Earth from './components/earth';
import Drawings from './components/drawings';
import ImageDetail from './components/imageDetail';
import Navbar from './components/navbar';
import Mail from './components/email';
import Contact from './components/contact';

function App() {
  const [user, setUser] = useState(null);
  const [images, setImages] = useState([]);

  const fetchImages = async (userId) => {
    try {
      const imagesRef = ref(storage, `images/${userId}/`);
      const imageList = await listAll(imagesRef);
      const urls = await Promise.all(
        imageList.items.map((item) => getDownloadURL(item))
      );
      setImages(urls);
    } catch (error) {
      console.error('Error fetching images:', error);
    }
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUser(user);
        fetchImages(user.uid);
      } else {
        console.log('No user is signed in.');
        setUser(null);
      }
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (analytics) {
      logEvent(analytics, "page_view");
    }
  }, []);

  return (
    <Router>
      <Navbar user={user} />
      <Languages />
      <Routes>
        <Route path="/" element={<ParticlesComponent />} />
        <Route path="/draw3D" element={<Draw />} />
        <Route path="/draw2D" element={<Draw2 />} />
        <Route path="/us" element={<Us />} />
        <Route path="/my-drawings" element={<MyDrawings userId={user ? user.uid : null} images={images} />} />
        {/* <Route path="/picture" element={<Picture />} /> */}
        <Route path="/blog" element={<Blog user={user} />} />
        <Route path="/article/:id" element={<ArticleDetail user={user} />} />
        <Route path="/stellarium" element={<Earth />} />
        <Route path="/drawings" element={<Drawings user={user}/>} />
        <Route path="/drawings/:imageId" element={<ImageDetail />} />
        <Route path="/contact" element={<Contact />} />
        <Route
          path="*"
          element={
            <>
              <Error />
              <Navigate to="/not-found" replace />
            </>
          }
        />
      </Routes>
      <Analytics />
    </Router>
  );
}

export default App;
